import React from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import numeral from 'numeral';
import Highcharts from 'highcharts';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import HighchartsReact from 'highcharts-react-official';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// Components
// import GroupCard from '../../components/GroupCard';

// Actions
import { gameActions } from '../../actions';

import Header from '../../components/Header';
import { DebriefMenu } from './debrief_menu';
// import infoModal from '../../assets/info-modal-1.png';

NoDataToDisplay(Highcharts);

// INLINE COMPONENTS
const TaskHistogram = ({ data, filter_amount, filter_accuracy }) => {
  const chartOptions = {
    chart: {
      type: 'column',
      height: 400,
      backgroundColor: 'transparent',
    },
    credits: {
      enabled: false,
    },
    title: {
      text: '',
    },
    xAxis: {
      type: 'category',
      title: {
        text: 'Processing Time (in seconds)',
      },
    },
    // avoid decimals in the y-axis
    yAxis: {
      min: 0,
      allowDecimals: false,
      title: {
        text: 'Fraction',
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><br/>',
      pointFormat:
        '<span style="color:{series.color}">{series.name}: </span>' +
        '<b>{point.y}</b><br/>',
    },
    series: [
      {
        name: 'Count',
        data: data.map((item) => ({
          name: item.group_name,
          y: item.value,
          group_id: item.group_id,
          task: item.task,
        })),
      },
    ],
    noData: {
      style: {
        fontSize: '16px',
        color: '#666',
      },
      position: {
        align: 'center',
        verticalAlign: 'middle',
      },
    },
  };

  return (
    <div className='task-histogram'>
      <HighchartsReact
        // ref={this.chartRef}
        highcharts={Highcharts}
        options={chartOptions}
        containerProps={{ style: { height: '400px', width: '100%' } }}
      />
      {filter_amount && (
        <div className='mt-3'>
          <h4>
            Filtered by {filter_amount} applications with an accuracy of{' '}
            {filter_accuracy}%
          </h4>
          <button
            className='btn btn-sm btn-link rounded-pill ps-0 mt-0 pt-0 mb-2'
            onClick={() => {
              this.selectAmount(null, null);
            }}>
            <small>Close Details</small>
          </button>
        </div>
      )}
    </div>
  );
};

// Methods
const sortByCreatedAt = (a, b) => {
  return new Date(a.created_at) - new Date(b.created_at);
};

class DebriefProcessingTime extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: this.props.item || null,
      popup: false,
      filter_amount: null,
      filter_accuracy: null,
      filter_group: null,
    };

    // Bindings
    this.selectAmount = this.selectAmount.bind(this);

    // Refs
    this.chartRef = React.createRef();
  }

  componentDidMount() {
    const { dispatch, match, game } = this.props;
    if (match.params.id && !game?.data?._id) {
      dispatch(gameActions.fetchGames(match.params.id));
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      item: newProps.item,
    });
  }

  selectAmount = (amount, accuracy) => {
    this.setState({ filter_amount: amount, filter_accuracy: accuracy }, () => {
      // Reflow the chart
      this.chartRef.current.chart.reflow();
    });
  };

  render() {
    // const { popup } = this.state;
    // const { filter_amount, filter_accuracy } = this.state;
    const { game } = this.props;
    const gameData = game.data;

    // X-axis time step
    const timeStep = 10 * 1000;

    // Tasks list
    const tasksNames = [
      'front-ratio',
      'back-ratio',
      'loan-to-value',
      'risk-assessment',
      'decision',
    ];

    // For every group calculate the number of decisions made and their performance
    const { filter_group } = this.state;
    const selectedGroups = filter_group
      ? gameData?.groups.filter((g) => g._id === filter_group)
      : gameData?.groups || [];
    const playersProcessingTime = selectedGroups.map((g, gi) => {
      // Group identifier
      const groupIdentifier = g?.name || `Group ${gi + 1}`;

      // Group results by task
      const taskResults = tasksNames.map((taskName) => {
        // Get all items for this task for this group
        const taskItems = g?.items?.filter((i) => i.activity === taskName);

        // Sort the taskItems by created_at (ascending)
        taskItems.sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );

        // Spent time is created_at - started_at
        const taskItemWIthElapsed = taskItems.map((item) => {
          let elapsed = 0;
          // If elapsed_time is available, use it
          if (item.elapsed_time) {
            elapsed = item.elapsed_time;
          }
          // If created_at and started_at are available, calculate the time difference
          if (item.created_at && item.started_at) {
            elapsed = new Date(item.created_at) - new Date(item.started_at);
          }

          return {
            group_id: g._id,
            group_name: groupIdentifier,
            task: taskName,
            value: elapsed,
          };
        });

        return taskItemWIthElapsed;
      });

      return taskResults.flat();
    });

    // console.log('playersProcessingTime', playersProcessingTime);

    // Calculate the histogram data for each task based on the average processing time
    // and count the number of groups that have the same average processing time or less
    const histogramData = tasksNames.map((taskName) => {
      const taskElapsedTime = playersProcessingTime
        .flat()
        .filter((item) => item.task === taskName)
        // Sort by created_at
        .sort(sortByCreatedAt)
        .map((item) => item.value);

      // console.log({ taskElapsedTime });

      // Create histogram bins
      const bins = Array.from({ length: 10 }, (_, i) => (i + 1) * timeStep);

      // Count the number of groups in each bin, excluding them from the next bin
      // This will create a cumulative histogram
      // where each bin represents the number of groups with an average processing time less than the bin
      const counts = bins.map(
        (bin, bindex) =>
          taskElapsedTime.filter((avg) => {
            // For each bin, except the last one, count the number of averages that are less than or equal to the bin
            // and greater than the previous bin (or 0 for the first bin)
            if (bindex === 0) {
              return avg <= bin;
            }

            // For the last bin, count all averages that are greater than the previous bin limit
            if (bindex === bins.length - 1) {
              return avg > bins[bins.length - 2];
            }

            return avg <= bin && avg > (bins[bindex - 1] || 0);
          }).length
      );

      return {
        task: taskName,
        bins,
        counts,
      };
    });

    // console.log('histogramData', histogramData);

    // Charts data
    const frontRatioData = histogramData.find((h) => h.task === 'front-ratio');
    const backRatioData = histogramData.find((h) => h.task === 'back-ratio');
    const loanToValueData = histogramData.find(
      (h) => h.task === 'loan-to-value'
    );
    const riskAssessmentData = histogramData.find(
      (h) => h.task === 'risk-assessment'
    );
    const decisionData = histogramData.find((h) => h.task === 'decision');

    return (
      <div>
        <Header />

        {/* <h2 className='mt-3 sec-title fs-3'>
          Processing Time{' '}
          <small className='float-end'>
            <DebriefMenu
              game_id={game.data._id}
              location={this.props.location}
            />
          </small>
        </h2> */}

        <h2 className='d-flex mt-3 sec-title fs-3'>
          <span className='d-none d-xl-inline text-nowrap'>
            Processing Time
          </span>
          {/* Display sub-menu on larger viewports */}
          <DebriefMenu
            className='small d-flex justify-content-between justify-content-xl-end align-items-center ms-xl-auto w-100'
            game_id={game.data._id}
            location={this.props.location}
          />
        </h2>

        <div className='row mt-3'>
          <div className='col-12 mb-2'>
            <p className='text-center'>
              Each histogram represents the distribution of the processing time
              spent on each type of task by the players.
            </p>

            {/* Group Selector */}
            <select
              className='form-select form-select-sm w-auto mx-auto mb-2'
              onChange={(e) => {
                const { value } = e.target;
                this.setState({ filter_group: value });
              }}>
              <option value=''>All Groups</option>
              {gameData?.groups?.map((g, i) => {
                const groupName = g.name.length > 0 ? g.name : `Group ${i + 1}`;
                return (
                  <option key={`group-${i}`} value={g._id}>
                    {groupName}
                  </option>
                );
              })}
            </select>
          </div>

          {/* CHARTS */}
          <div className='col-12'>
            <div className='d-flex gap-3 justify-content-between'>
              {/* FRONT-RATIO */}
              <div className='mb-4 pt-3 w-100 shadow bg-white border text-center'>
                <h3 className='h6 fw-bold'>Front Ratio</h3>
                <TaskHistogram
                  data={frontRatioData.counts // Map the counts to the data format
                    .map((count, index) => ({
                      group_name:
                        index < frontRatioData.bins.length - 1
                          ? (timeStep * (index + 1)) / 1000 + `s`
                          : `${(timeStep * (index + 1)) / 1000}s+`,
                      value: count,
                      group_id: `bin-${index + 1}`,
                      task: 'front-ratio',
                    }))}
                />
              </div>

              {/* BACK-RATIO */}
              <div className='mb-4 pt-3 w-100 shadow bg-white border text-center'>
                <h3 className='h6 fw-bold'>Back Ratio</h3>
                <TaskHistogram
                  data={backRatioData.counts // Map the counts to the data format
                    .map((count, index) => ({
                      group_name:
                        index < backRatioData.bins.length - 1
                          ? (timeStep * (index + 1)) / 1000 + `s`
                          : `${(timeStep * (index + 1)) / 1000}s+`,
                      value: count,
                      group_id: `bin-${index + 1}`,
                      task: 'back-ratio',
                    }))}
                />
              </div>

              {/* LOAN-TO-VALUE */}
              <div className='mb-4 pt-3 w-100 shadow bg-white border text-center'>
                <h3 className='h6 fw-bold'>Loan to Value</h3>
                <TaskHistogram
                  data={loanToValueData.counts // Map the counts to the data format
                    .map((count, index) => ({
                      group_name:
                        index < loanToValueData.bins.length - 1
                          ? (timeStep * (index + 1)) / 1000 + `s`
                          : `${(timeStep * (index + 1)) / 1000}s+`,
                      value: count,
                      group_id: `bin-${index + 1}`,
                      task: 'loan-to-value',
                    }))}
                />
              </div>
            </div>

            <div className='d-flex gap-3 justify-content-center mx-5 px-5 mb-5'>
              {/* RISK-ASSESSMENT */}
              <div className='mb-4 pt-3 w-50 shadow bg-white border text-center'>
                <h3 className='h6 fw-bold'>Risk Assessment</h3>
                <TaskHistogram
                  data={riskAssessmentData.counts // Map the counts to the data format
                    .map((count, index) => ({
                      group_name:
                        index < riskAssessmentData.bins.length - 1
                          ? (timeStep * (index + 1)) / 1000 + `s`
                          : `${(timeStep * (index + 1)) / 1000}s+`,
                      value: count,
                      group_id: `bin-${index + 1}`,
                      task: 'risk-assessment',
                    }))}
                />
              </div>

              {/* DECISION */}
              <div className='mb-4 pt-3 w-50 shadow bg-white border text-center'>
                <h3 className='h6 fw-bold'>Decision</h3>
                <TaskHistogram
                  data={decisionData.counts // Map the counts to the data format
                    .map((count, index) => ({
                      group_name:
                        index < decisionData.bins.length - 1
                          ? (timeStep * (index + 1)) / 1000 + `s`
                          : `${(timeStep * (index + 1)) / 1000}s+`,
                      value: count,
                      group_id: `bin-${index + 1}`,
                      task: 'decision',
                    }))}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { player, game } = state;
  return {
    game,
    player,
  };
}

export default connect(mapStateToProps)(DebriefProcessingTime);
